<template>
  <div class="modal fade" id="modal-cancel-reason" tabindex="-1" role="dialog" aria-labelledby="modal-cancel-reason" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <h3>Why did you cancel the booking?</h3>
          <button
            v-for="option in withdrawal_options"
            :key="option.id"
            type="button"
            class="btn btn-block btn-dark"
            data-dismiss="modal"
            @click="handleCancelBookingReasonCallback(option.id)">
            {{ option.label }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleCancelBookingReasonCallback (reason) {
      this.$emit('input', reason)
    }
  },

  data () {
    return {
      withdrawal_options: [
        { id: 'scheduling', label: 'Scheduling Issue' },
        { id: 'no_replacement', label: 'No Replacement Found' },
        { id: 'budget', label: 'Budget Issue' },
        { id: 'accidental_booking', label: 'Accidental Booking' },
        { id: 'covid19', label: 'Covid-19' },
        { id: 'not_proceeding', label: 'Opportunity Not Going Ahead' },
        { id: 'talent_withdrawal', label: 'Talent Withdrawal' },
        { id: 'client_withdrawal', label: 'Client Withdrawal' },
        { id: 'other', label: 'Other' }
      ]
    }
  }
}
</script>
